<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbsItems"></v-breadcrumbs>
  </v-container>
</template>

<script>
import { handleError } from "@/helpers/helper";

export default {
  name: "Logout",
  data: () => ({
    breadcrumbsItems: []
  }),
  created() {
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });

    let self = this;
    this.$store
      .dispatch("logout")
      .then(() => {
        self.$router.push({ name: "Login" });
      })
      .catch(error => {
        let result = handleError(
          error,
          self.$toasted,
          self.$router,
          self.$store
        );
        for (var item in result) {
          self.$toasted.error(result[item], {
            duration: 5000,
            keepOnHover: true,
            className:
              self.$store.getters.LANGUAGE == "fa"
                ? "vazir-font-fd"
                : "vazir-font",
            iconPack: "fontawesome",
            icon: "exclamation-triangle",
            position: "top-center"
          });
        }
      });
  }
};
</script>
